import { render, staticRenderFns } from "./CelebrationModal.vue?vue&type=template&id=1a811d78&scoped=true"
import script from "./CelebrationModal.vue?vue&type=script&lang=ts"
export * from "./CelebrationModal.vue?vue&type=script&lang=ts"
import style0 from "./CelebrationModal.vue?vue&type=style&index=0&id=1a811d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a811d78",
  null
  
)

export default component.exports